//REACT
import React, { useState } from 'react'
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import { Link, useLocation } from 'react-router-dom';
import Facebook from '@material-ui/icons/Facebook';
import Instagram from '@material-ui/icons/Instagram';

//Material-UI
// import { makeStyles } from "@material-ui/core/styles";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// // core components
// import Footer from "components/Footer/Footer.js"
// import Button from "components/CustomButtons/Button.js";
// import Slide from "@material-ui/core/Slide";
// import Dialog from "@material-ui/core/Dialog";
// import DialogTitle from "@material-ui/core/DialogTitle";
// import DialogContent from "@material-ui/core/DialogContent";
// import DialogActions from "@material-ui/core/DialogActions";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
// import Card from "components/Card/Card.js";
// import Close from "@material-ui/icons/Close";

// import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";
// import styleModal from "assets/jss/material-kit-pro-react/modalStyle.js";
// // react components for routing our app without refresh
// import { Link } from "react-router-dom";
// import style from 'assets/jss/material-kit-pro-react/views/componentsSections/footerStyle';
// // const useStyles = makeStyles(styles);
// // const useStylesModal = makeStyles(styleModal);

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="down" ref={ref} {...props} />;
// });

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
  },
  largeIcon: {
    fontSize: '2.6rem',
  }
});

export default function PiePagina() {
  const classes = useStyles()
  // const classesModal = useStylesModal()
  // const [openModal, setopenModal] = useState(false);
  // const [openModalResolucion, setopenModalResolucion] = useState(false);

  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);

  const handleMouseEnter1 = () => {
    setIsHovered1(true);
  };

  const handleMouseLeave1 = () => {
    setIsHovered1(false);
  };

  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  function getWPUrl(path) {
    return path ? window.urlWP + path : window.urlWP;
  }

  return (
    <div>
      <div position="static" style={{backgroundColor: "#ddd", fontSize: "20px", borderStyle: "solid", borderWidth: "0px", borderTopWidth: "1px", borderTopColor: "#e6e6e6"}}>
        <Toolbar style={{ display: 'flex', justifyContent: 'center', paddingTop: '2.5rem', paddingBottom: '2.5rem' }}>
          <Link to="#"
            onClick={e => window.open(getWPUrl(), '_self')}
            style={{ textDecoration: 'none', marginRight: '2rem', color: isHovered1 ? "#8FC600" : "#16162E", fontWeight: "400" }}
            onMouseEnter={handleMouseEnter1}
            onMouseLeave={handleMouseLeave1}
          >Inicio</Link>
          <Link to="#"
            onClick={e => window.open(getWPUrl("/legales"), '_self')}
            style={{ textDecoration: 'none', marginRight: '2rem', color: isHovered2 ? "#8FC600" : "#16162E", fontWeight: "400" }}
            onMouseEnter={handleMouseEnter2}
            onMouseLeave={handleMouseLeave2}
          >Documentos Legales</Link>
        </Toolbar>
      </div>
      <div position="static" style={{backgroundColor: "#f9f9f9", fontSize: "20px", borderStyle: "solid", borderWidth: "0px", borderTopWidth: "1px", borderTopColor: "#e6e6e6"}}>
        <Toolbar style={{ display: 'flex', justifyContent: 'center', paddingTop: '3.4rem', paddingBottom: '3.4rem' }}>
          <Link to="#"
            onClick={e => window.open("https://www.instagram.com/firmadox_chile/", '_blank')}
            style={{ textDecoration: 'none', marginRight: '2rem', color: "#8FC600" }}
          >
            <Facebook className={classes.largeIcon}/>
          </Link>
          <Link to="#"
            onClick={e => window.open("https://www.instagram.com/firmadox_chile/", '_blank')}
            style={{ textDecoration: 'none', marginRight: '2rem', color: "#8FC600" }}
          >
            <Instagram className={classes.largeIcon}/>
          </Link>
        </Toolbar>
      </div>
      <div position="static" style={{backgroundColor: "#fff", fontSize: "20px", borderStyle: "solid", borderWidth: "0px", borderTopWidth: "1px", borderTopColor: "#e6e6e6"}}>
        <Toolbar style={{ display: 'flex', justifyContent: 'center', paddingTop: '2rem', paddingBottom: '2rem', fontWeight: "400" }}>
          Copyright © 2024 | Firmadox
        </Toolbar>
      </div>
      {/* <Dialog
      disableBackdropClick
      classes={{
        root: classesModal.modalRoot,
        paper: classesModal.modal + " " + classesModal.modal
      }}
      open={openModal}
      TransitionComponent={Transition}
      keepMounted
      //onClose={() => setopenModal(false) }
      aria-labelledby="modal-slide-title"
      aria-describedby="modal-slide-description"
      maxWidth='sm'

    >
      <DialogTitle
          id="modal-slide-title"
          disableTypography
          className={classesModal.modalHeader}
        >
        <Button
            simple
            className={classesModal.modalCloseButton}
            key="close"
            aria-label="Close"
            onClick={() => setopenModal(false)}
          >
            {" "}
            <Close className={classesModal.modalClose} />
          </Button>
          <h3 className={classesModal.cardTitle + " " + classesModal.modalTitle}>
          <GridContainer justify="center">
            Políticas y Prácticas
          </GridContainer>
          </h3>

        </DialogTitle>
        <DialogContent id="modal-slide-description" className={classesModal.modalBody}>
          <GridContainer justify="right" maxWidth ='lg'>
            <GridItem xs={12} sm={10} md={20}  className={classesModal.mrAuto}>
              <form className={classesModal.form}>
              <p className={classes.Block}  style={{padding: 0}}>
                Descarga de Documentos:
                </p>
              <p>
                <Link to="#" style={{color: "#a1c330", textDecoration: "underline"}} onClick={e =>window.open(window.pdfPracticasCertificacion, '_blank')}>
                  Declaración de Prácticas de Certificación
                </Link>
                <br></br>
                <br></br>
                <Link to="#" style={{color: "#a1c330", textDecoration: "underline"}} onClick={e =>window.open(window.pdfPoliticaFirmaAvanzada, '_blank')}>
                  Política de Firma Avanzada
                </Link>
                <br></br>
                <br></br>
                <Link to="#" style={{color: "#a1c330", textDecoration: "underline"}} onClick={e =>window.open(window.pdfPoliticaPrivacidad, '_blank')}>
                  Política de Privacidad
                </Link>
                </p>
              </form>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
        <Button autoFocus onClick={e=>setopenModal(false)} color="primary">
          Cerrar
        </Button>
      </DialogActions>
      </Dialog>
      <Dialog
        disableBackdropClick
        classes={{
          root: classesModal.modalRoot,
          paper: classesModal.modal + " " + classesModal.modal
        }}
        open={openModalResolucion}
        TransitionComponent={Transition}
        keepMounted
        //onClose={() => setopenModal(false) }
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
          <DialogTitle
            id="signup-modal-slide-title"
            disableTypography
            className={classesModal.modalHeader}
          >
            <Button
              simple
              className={classesModal.modalCloseButton}
              key="close"
              aria-label="Close"
              onClick={() => setopenModalResolucion(false)}
            >
              {" "}
              <Close className={classesModal.modalClose} />
            </Button>
            <h3 className={classesModal.cardTitle + " " + classesModal.modalTitle}>
            <GridContainer justify="center">
              Resoluciones
              </GridContainer>
            </h3>
          </DialogTitle>
          <DialogContent id="modal-slide-description" className={classesModal.modalBody}>
            <GridContainer justify="left">
              <GridItem xs={12} sm={10} md={10} className={classesModal.mrAuto}>
                <form className={classesModal.form}>
                  <Link to="#" style={{color: "#a1c330", textDecoration: "underline"}} onClick={e =>window.open(window.pdfAcreditacionFEA, '_blank')}>
                      Acreditación de firma electrónica avanzada
                    </Link>
                </form>
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
          <Button autoFocus onClick={e=>setopenModalResolucion(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <Footer
        theme="dark"
        content={
          <div>
            <div className={classes.left}>
              <a
                href="http://www.firmadox.cl"
                className={classes.footerBrand}
              >
                FirmaDOX
              </a>
            </div>
            <div className={classes.pullCenter}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <Link to="#" className={classes.block}>
                    Copyright &copy; {1900 + new Date().getYear()}{" "}
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <Link to="#" className={classes.block} onClick={e =>setopenModal(true)}>
                    Políticas y Prácticas
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <Link to="#" className={classes.block} onClick={e =>setopenModalResolucion(true)}>
                    Resoluciones
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <Link to="#" className={classes.block} onClick={e =>window.open(window.pdfContratoAdhesion, '_blank')}>
                    Términos de Uso
                  </Link>
                </ListItem>
              </List>
            </div>

          </div>
        }
      /> */}
    </div>
  )
}
